<template>
  <section>
    <header class="header">
      <LangSelector />
    </header>

    <div class="container">
      <h1
        class="pagetitle"
        :class="{ 'pagetitle-fallback': ['hr', 'cs'].includes($i18n.locale) }"
      >
        {{ $t("Intro.header") }}
      </h1>
      <div class="box">
        <div v-html="$t('Intro.body')"></div>
        <p class="disclaimer">{{ $t("Intro.disclaimer") }}</p>
        <button class="button" @click="next">{{ $t("Intro.button") }}</button>
      </div>
    </div>
  </section>
</template>

<script>
import LangSelector from "@/components/LangSelector";

export default {
  name: "Intro",
  components: {
    LangSelector
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE
    };
  },
  methods: {
    next() {
      this.$store.dispatch("showNextScreen");
    }
  }
};
</script>

<style scoped>
.disclaimer {
  padding-left: 0.75rem;
}
.disclaimer:before {
  position: absolute;
  content: "*";
  font-weight: 700;
  margin-left: -0.75rem;
}
</style>
